import { Appointment } from '$api-client/types.gen'
import { AppointmentStatusPill } from '$components'
import { EntityLink } from '$components'
import { ServicePill } from '$components'
import { AppointmentRoutePath } from '$features/appointments/routes/protected'
import { AppointmentsFilterParam } from '$features/appointments/enums/filter-params'
import { PetRoutePaths } from '$features/pets/routes/protected'
import { PetsFilterParam } from '$features/pets/enums/filter-params'
import { TeamRoutePath } from '$features/team/routes/protected'
import { AppointmentHelper } from '$components'
import { Router } from '$utils/router'
import { Text, Card } from '$components'
import { ArrowLongRightIcon } from '$components'
import dayjs from 'dayjs'
import { Link } from 'react-router-dom'

export type UpcomingAppointmentCardProps = {
  data: Appointment,
  showPet?: boolean,
}

export function UpcomingAppointmentCard({ data, showPet = false }: UpcomingAppointmentCardProps) {
  return (
    <Card
      rounding="xl"
      padding="sm"
    >
      <Card.Content padding="sm">
        <div className="flex sm:flex-row flex-col justify-between items-start gap-4">
          <div className="flex flex-col gap-4">
            <Link
              to={Router.getRoute(
                AppointmentRoutePath.AppointmentsView,
                { id: data.id },
                !data.approved_at ? { [AppointmentsFilterParam.IncludeUnapproved]: '1' } : undefined,
              )}
              className="hover:underline"
            >
              <Text
                type="h4"
                className="flex items-center text-nowrap flex-wrap gap-2"
              >
                {dayjs(data.start_at).format('DD MMM YYYY HH:mm A')}
                <ArrowLongRightIcon className="size-4" />
                {dayjs(data.finish_at).format('HH:mm A')}
                <span className="text-gray-700">
                  ({AppointmentHelper.calculateAppointmentDuration(data.start_at, data.finish_at)})
                </span>
              </Text>
            </Link>

            <div className="flex gap-1">
              {data.services.map((service) => (
                <ServicePill
                  key={service.id}
                  service={{
                    id: service.service.id,
                    values: {
                      id: service.service_values.id,
                      is_latest: service.service_values.is_latest,
                      name: service.service_values.name,
                    },
                    colour: service.service.colour,
                  }}
                />
              ))}
            </div>

            {showPet && (
              <EntityLink
                path={Router.getRoute(
                  PetRoutePaths.PetsView,
                  { id: data.pet.id.toString() },
                  !data.pet.approved_at ? { [PetsFilterParam.IncludeUnapproved]: '1' } : undefined,
                )}
                image={data.pet.image}
                iconSize="md"
              >
                {data.pet.name}
              </EntityLink>
            )}

            {data.groomer && (
              <EntityLink
                path={Router.getRoute(TeamRoutePath.TeamMemberView, { id: data.groomer.id })}
                image={data.groomer.image}
                iconSize="md"
              >
                {`${data.groomer.first_name} ${data.groomer.last_name}`}
              </EntityLink>
            )}
          </div>

          <AppointmentStatusPill status={data.status} />
        </div>

        {data.notes && (
          <Text className="text-sm text-gray-700 mt-2">
            {data.notes}
          </Text>
        )}
      </Card.Content>
    </Card>
  )
}
